import type { HTMLAttributes, PropsWithChildren } from "react";

import { cn } from "../../lib/cn";

export function Badge({ children, className, ...rest }: PropsWithChildren<HTMLAttributes<HTMLSpanElement>>) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-ink-soft",
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
